import { render, staticRenderFns } from "./VikiMsgStats.container.vue?vue&type=template&id=a47311be&scoped=true&"
import script from "./VikiMsgStats.container.vue?vue&type=script&lang=js&"
export * from "./VikiMsgStats.container.vue?vue&type=script&lang=js&"
import style0 from "./VikiMsgStats.container.vue?vue&type=style&index=0&id=a47311be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47311be",
  null
  
)

export default component.exports